export const ON_CONTACT_SAVE = (state, payload) => {
  if (typeof payload === "function") {
    state.contactSaveListener = payload;
    state.pendingContactSelection = null;
    return;
  }

  state.contactSaveListener = payload?.listener || null;
  state.pendingContactSelection = payload?.context
    ? { ...payload.context, contactID: null }
    : null;
};

export const CONTACT_SAVED = (state, contact) => {
  if (state.contactSaveListener) {
    state.contactSaveListener(contact);
    state.contactSaveListener = null;
  }

  if (!state.pendingContactSelection) {
    return;
  }

  state.pendingContactSelection = {
    ...state.pendingContactSelection,
    contactID: contact.id,
  };
};

export const CONSUME_PENDING_CONTACT_SELECTION = (state) => {
  state.pendingContactSelection = null;
};

export const ON_ADDRESS_ADD = (state, { contactID, existingKeys, context }) => {
  state.pendingAddressSelection = {
    ...(context || {}),
    contactID,
    existingKeys: existingKeys || [],
    address: null,
  };
};

export const SET_PENDING_ADDRESS = (state, address) => {
  if (!state.pendingAddressSelection) {
    return;
  }

  state.pendingAddressSelection = {
    ...state.pendingAddressSelection,
    address,
  };
};

export const CONSUME_PENDING_ADDRESS_SELECTION = (state) => {
  state.pendingAddressSelection = null;
};

export const SET_IGNORED_DUPLICATE_GROUPS = (state, groups) => {
  state.ignoredDuplicatePairs = groups;
};
